import { Message } from 'element-ui';

// 你可以用本地图片地址、SVG 或网络图片，这里举例用网络图片
const closeIconUrl = require('../assets/dialog/close-modal-dark.png');

const icons = {
    success: require(`../assets/success.png`),
    error: require(`../assets/custom-token/warn.png`),
    warn: require(`../assets/custom-token/warn.png`),
};

/**
 * TransitMessage 支持三种 message 形式：
 * 1. 普通字符串（可以包含 <a href="...">...</a>） — 会原样插入（dangerouslyUseHTMLString: true）
 * 2. 包含 data-action 的 HTML 字符串，例如: '点击 <a href="#" data-action="open">这里</a>'
 *    并通过 actions 参数传入对应 handler
 * 3. segments 数组：[{ text: '请 ', }, { text: '点击这里', action: 'open', class: 'link' }, ...]
 *
 * options:
 * - message: string | Array(segments)
 * - type: 'success' | 'error' | 'warn' (不会传给 Message 的 type)
 * - duration: 毫秒
 * - actions: { [actionName]: (event, instance) => void } // 用于 data-action 或 segments 中的 action
 * - closeOnAction: boolean (默认 true) // action 点击后是否自动关闭 message
 */
function TransitMessage({
    message = '',
    type = 'success',
    duration = 3 * 1000,
    actions = {},
    closeOnAction = true,
} = {}) {
    // helper: escape plain text when building from segments to avoid injection
    const escapeHtml = str =>
        String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');

    let contentHtml = '';

    if (Array.isArray(message)) {
        // build from segments
        contentHtml = message
            .map(seg => {
                const txt = seg.text != null ? escapeHtml(seg.text) : '';
                if (seg.action) {
                    const cls = seg.class ? ` ${escapeHtml(seg.class)}` : '';
                    const title = seg.title ? ` title="${escapeHtml(seg.title)}"` : '';
                    // data-action 用于后续挂事件
                    return `<a href="javascript:void(0)" class="transit-action${cls}" data-action="${escapeHtml(
                        seg.action
                    )}"${title}>${txt}</a>`;
                }
                // 支持传入 HTML 字符串段（不推荐），可通过 seg.raw = true
                if (seg.raw) return seg.text || '';
                return `<span>${txt}</span>`;
            })
            .join('');
    } else {
        // message 是字符串：我们允许用户传入 HTML（已经使用 dangerouslyUseHTMLString）
        // 如果用户想绑定事件，需要在 HTML 中使用 data-action="..." 并在 actions 中提供 handler
        contentHtml = String(message);
    }

    const html = `
      <img class="type-icon" src="${icons[type] || icons['success']}"/>
      <span style="flex:1; display:flex; align-items:center; justify-content: center;">${contentHtml}</span>
      <img class="close-msg" src="${closeIconUrl}"/>
  `;
    const instance = Message({
        dangerouslyUseHTMLString: true,
        message: html,
        duration,
        showClose: false, // 必须 false（我们自定义关闭图标）
        // 不要传 type 给 el-message，避免 element 自带样式影响
    });

    // 等待 el-message 元素插入 DOM，然后挂载事件
    setTimeout(() => {
        const doms = document.querySelectorAll('.el-message');
        const lastMsg = doms[doms.length - 1];
        if (!lastMsg) return;

        // 关闭按钮行为
        const closeBtn = lastMsg.querySelector('.close-msg');
        if (closeBtn) closeBtn.onclick = () => instance.close();

        // data-action 的元素行为
        const actionEls = lastMsg.querySelectorAll('[data-action]');
        actionEls.forEach(el => {
            const actionName = el.getAttribute('data-action');
            const handler = actions && actions[actionName];
            // 如果提供了 handler，就阻止默认，执行 handler
            if (typeof handler === 'function') {
                el.addEventListener('click', e => {
                    try {
                        handler(e, instance);
                    } catch (err) {
                        // 捕获 handler 内错误，避免影响其他消息
                        // eslint-disable-next-line no-console
                        console.error('TransitMessage action handler error:', err);
                    }
                    if (closeOnAction) instance.close();
                });
            }
            // 如果没有 handler，但元素是 <a href="...">，则保留默认行为（打开链接）
        });
    }, 30);

    return instance;
}

export default TransitMessage;

// 使用示例：
// 1) 直接传 HTML 字符串（可包含普通链接或 data-action）
// TransitMessage({
//   message: '查看详情 <a href="#" data-action="openDetail">点我</a>',
//   actions: {
//     openDetail: (e, instance) => {
//       e.preventDefault()
//       // 比如使用 vue-router 跳转
//       // router.push({ name: 'Detail' })
//       window.alert('open detail action called')
//     }
//   }
// })

// 2) 传 segments（更安全，自动 escape）
// TransitMessage({
//   message: [
//     { text: '请阅读 ' },
//     { text: '协议', action: 'openProtocol', class: 'link-text' },
//     { text: ' 后继续' }
//   ],
//   actions: {
//     openProtocol: () => {
//       window.open('/protocol', '_blank')
//     }
//   }
// })
